import React, {Component} from 'react';
import {connect} from 'react-redux';
import {replace} from 'react-router-redux';
import Checkin from 'components/Checkin/Checkin';
import {getURL} from '../routes';

class Home extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.role === 0)
      this.props.dispatch(replace(getURL('/ws-admin')));
  }

  render() {
    let isWorker = this.props.userName !== '' 
                    && !(this.props.role === 0 || this.props.role === undefined)
    return (
      <div className="App">
        {isWorker &&
          <Checkin {...this.props} />}
      </div>
    );
  }
}

export default connect((state) => ({
  userName: state.auth.get('userName'),
  role: state.auth.get('role'),
  current: state.checkin.get('current'),
  upcoming: state.checkin.get('upcoming'),
  sessionConfig: state.session.get('config'),
}))(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js